// Form doğrulama yardımcı işlevleri

// E-posta doğrulama
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Şifre doğrulama (güçlü şifre kontrolü)
export const isValidPassword = (password) => {
  // En az 8 karakter, bir büyük harf, bir küçük harf ve bir sayı içermeli
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
  return passwordRegex.test(password);
};

// Adı veya soyadı doğrulama (boş olmamalı)
export const isValidName = (name) => {
  return name && name.trim().length > 0;
};

// Telefon numarası doğrulama (tam 10 haneli olmalı)
export const isValidPhone = (phone) => {
  const phoneRegex = /^[0-9]{10}$/;
  return phoneRegex.test(phone);
};

// TC Kimlik Numarası doğrulama (11 haneli olmalı)
export const isValidTCID = (tcId) => {
  // Boş veya undefined ise geçerli kabul et (isteğe bağlı alan)
  if (!tcId || tcId.trim() === '') {
    return true;
  }
  
  // Dolu ise 11 haneli sayı olmalı
  return /^[1-9][0-9]{10}$/.test(tcId);
};

// İki şifrenin eşleşip eşleşmediğini kontrol et
export const passwordsMatch = (password, confirmPassword) => {
  return password === confirmPassword;
};

// Fiyat doğrulama (sıfırdan büyük olmalı)
export const isValidPrice = (price) => {
  return price && !isNaN(price) && parseFloat(price) >= 0;
};

// Form hatalarını gösterme
export const getFormErrors = (formData, validationRules) => {
  const errors = {};
  
  Object.keys(validationRules).forEach(field => {
    const value = formData[field];
    const validationFn = validationRules[field].validator;
    const message = validationRules[field].message;
    
    if (validationFn && !validationFn(value)) {
      errors[field] = message;
    }
  });
  
  return errors;
};
